import { useMemo } from 'react';
import { without } from 'lodash';

import { CHANNEL, PLATFORM_CHANNEL } from 'src/data/channel';
import { useCustomerTwitterSocialIntegrationEnabled } from 'src/store';

const AVAILABLE_CHANNELS = [
  CHANNEL.google,
  CHANNEL.facebook,
  CHANNEL.linkedin,
  CHANNEL.instagram,
  CHANNEL.facebookPages,
  CHANNEL.linkedinSocial,
  CHANNEL.twitterSocial,
  PLATFORM_CHANNEL.projectWtm,
  PLATFORM_CHANNEL.blogUrls,
];

export const useVisibleIntegrationChannels = ({
  isTrainingModel,
  hideWtmIntegration,
  displayBlogURLs,
}) => {
  const shouldIncludeTwitterSocial = useCustomerTwitterSocialIntegrationEnabled();

  return useMemo(() => {
    let result = AVAILABLE_CHANNELS;

    if (!shouldIncludeTwitterSocial) {
      result = without(result, CHANNEL.twitterSocial);
    }

    if (isTrainingModel) {
      result = without(
        result,
        CHANNEL.google,
        PLATFORM_CHANNEL.projectWtm,
        PLATFORM_CHANNEL.blogUrls
      );
    }

    if (hideWtmIntegration) {
      result = without(result, PLATFORM_CHANNEL.projectWtm);
    }

    if (!displayBlogURLs) {
      result = without(result, PLATFORM_CHANNEL.blogUrls);
    }

    return result;
  }, [displayBlogURLs, hideWtmIntegration, isTrainingModel, shouldIncludeTwitterSocial]);
};
